import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { ButtonGroupContext } from "../Button/ButtonGroupContext.js";
import { P } from "../Text/index.js";
import { actionFooterVariants } from "./ActionFooter.variants.js";
function ActionFooter({ children, headerContent, helperText, floating = false, shadow = true, barType, actionDisplay, className, slots = {}, ...props }) {
    const { root, contentWrapper, mainContainer, headerContainer, helperTextSlot } = actionFooterVariants({
        barType,
        actionDisplay,
        floating
    });
    const domProps = cleanProps(props, Object.keys(actionFooterVariants.variants));
    const rootClasses = root({
        className: cn(shadow ? void 0 : 'shadow-none', className, slots.root)
    });
    const resolvedDisplay = actionDisplay ?? 'lg';
    const buttonCtx = useMemo(()=>'lg' === resolvedDisplay ? {
            size: 'lg',
            fullWidth: true
        } : {
            size: 'md',
            fullWidth: false
        }, [
        resolvedDisplay
    ]);
    return /*#__PURE__*/ jsx(ButtonGroupContext.Provider, {
        value: buttonCtx,
        children: /*#__PURE__*/ jsxs("div", {
            ...domProps,
            className: rootClasses,
            children: [
                headerContent && /*#__PURE__*/ jsx("div", {
                    className: headerContainer({
                        className: slots.headerContainer
                    }),
                    children: headerContent
                }),
                /*#__PURE__*/ jsxs("div", {
                    className: contentWrapper({
                        className: slots.contentWrapper
                    }),
                    children: [
                        /*#__PURE__*/ jsx("div", {
                            className: mainContainer({
                                className: slots.mainContainer
                            }),
                            children: children
                        }),
                        helperText && /*#__PURE__*/ jsx(P, {
                            className: helperTextSlot({
                                className: slots.helperTextSlot
                            }),
                            palette: "neutral",
                            shade: "13",
                            children: helperText
                        })
                    ]
                })
            ]
        })
    });
}
ActionFooter.displayName = 'ActionFooter';
export { ActionFooter };
